import iconInfo from "assets/imgs/icons/transaction-info.svg";
import React, { useEffect, useState } from "react";
import { getTransactionColor, mapCorporationMemberRows } from "utils";
import API from "api/API";
import { Corporation, CorporationMemberRow } from "api/Models";
import ExtendingButton from "components/elements/ExtendingButton";
import Table, { ChipCell, DateTimeCell, LazyTextCell, PhoneCell, SplitTextCell, TagCell, TextCell } from "components/elements/Table";

interface CorporationTableProps {
    //filters: TransactionFilter
    // corporation: string
    pageSize?: number
    noFetch?: boolean
}

function CorporationTable(props: CorporationTableProps) {
    const tableColumns = [
        "Name",
        "Account Number",
        "Created On",
        "Category",
        "Registration Code",
        "Address",
        "Owner",
        "Users",
        "Cards",
        "Actions",
    ]

    const [corporations, setCorporations] = useState<CorporationRow[]>([])
    const [page, setPage] = useState(1)
    const [totalPageCount, setTotalPageCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const pageSize = props.pageSize ?? 10;

    useEffect(() => {
        setLoading(true)

        if (props.noFetch) {
            return;
        }

        const skip = (page - 1) * pageSize;

        API.Corporations.GetCorporations(skip, pageSize)
            .then(result => {
                if (result.success && result.data) {
                    setTotalPageCount(Math.ceil(result.data.totalCount / result.data.pageSize))
                    setCorporations(mapCorporationRows(result.data.data))
                }
            }).finally(() => setLoading(false))

    }, [props, page, pageSize])

    const rowRenderer = (row: CorporationRow) => {
        return [
            <TextCell text={row.name} />,
            <TextCell text={row.accountNumber} />,
            <DateTimeCell date={row.createdOn} />,
            <TextCell text={row.category} />,
            <TextCell text={row.registrationCode} />,
            <TextCell text={row.address} />,
            <TextCell text={row.owner} />,
            <TextCell text={row.numberOfUsers.toString()} />,
            <LazyTextCell key={row.id}
                fetchData={async () => {
                    const result = await API.Cards.GetCards({ corporationId: row.id, 'offsetPaging.skip': 0, 'offsetPaging.take': 1 })
                    return result.data?.totalCount.toString() ?? "0"
                }}
            />,
            // <SplitTextCell texts={row.name.split(",").map(s => s.trim())}/>,
            // <PhoneCell phone={row.phoneNumber}/>,
            // <TextCell text={row.email}/>,
            // <TextCell text={row.occupation}/>,
            // // <ChipCell chips={row.roles.split(',')}/>,
            // <TagCell text={row.status} color={getTransactionColor(row.status)}/>,
            // <DateTimeCell date={row.lastLogin}/>,
            // <ExtendingButton to={"/user-management/" + props.corporation + "/user/" + row.userId} icon={iconInfo} label="Settings" type="outline-primary"/>,
            <div>
                Action buttons go here
            </div>
        ]
    }

    return <Table columns={tableColumns}
        loading={loading}
        page={page}
        totalPageCount={totalPageCount}
        onPageChange={setPage}
        data={corporations}
        rowRenderer={rowRenderer} />
}


// export interface Corporation {
// 	id: string
// 	tenantId: string
// 	externalCorporationId: number
// 	externalCustomerId: number
// 	name: string
// 	customerSubtypeCode: string
// 	customerGroupCode: string
// 	relatedPersons: any[]
// 	registrationCountryCode: string
// 	status: string
// 	registrationRiskCountryCode: string
// 	registrationCode: string
// 	registrationDate: string
// 	vatCode: string
// 	registrationNumber: string
// 	registrationAddressLine: string
// 	registrationAddressTownId: string
// 	registrationAddressZipCode: string
// 	mailingCountryCode: string
// 	mailingAddressTownId: string
// 	mailingAddressZipCode: string
// 	mailingAddressLine: string
// 	preferredLanguageCode: string
// 	checkAML: boolean
// 	phoneNumber: PhoneNumber
// 	email: string
// 	folderId: string
// 	cardEnabled: boolean
// 	createdBy: string
// 	modifiedBy: string | null
// 	createdOn: string
// 	modifiedOn: string
// }

/**
 * {
    "data": [
        {
            "id": "1258330192301371392",
            "tenantId": "1258302372600094720",
            "externalCorporationId": 28207,
            "externalCustomerId": 138333,
            "name": "CorpOne",
            "customerSubtypeCode": "MB",
            "customerGroupCode": "EASYPS_CUST",
            "relatedPersons": [
                {
                    "id": "1258330192330731520",
                    "tenantId": "1258302372600094720",
                    "status": "Active",
                    "userId": "1258307655580364800",
                    "isMainPerson": true,
                    "occupation": "Director",
                    "folderId": null,
                    "roles": "create_transfers,manage_transfers,read_transfers,manage_accounts,open_accounts,read_accounts,create_cards,manage_cards,read_cards,manage_beneficiaries,read_customers",
                    "createdOn": "2024-07-04T07:54:56.497Z",
                    "modifiedOn": "2024-07-04T12:42:23.346Z",
                    "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
                    "modifiedBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be"
                },
                {
                    "id": "1258402411719274496",
                    "tenantId": "1258302372600094720",
                    "status": "Active",
                    "userId": "1258398250311200768",
                    "isMainPerson": false,
                    "occupation": "Expert",
                    "folderId": "",
                    "roles": "create_transfers,manage_transfers,read_transfers,manage_accounts,open_accounts,read_accounts,create_cards,manage_cards,read_cards,manage_beneficiaries,read_customers",
                    "createdOn": "2024-07-04T12:41:54.940Z",
                    "modifiedOn": null,
                    "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
                    "modifiedBy": null
                },
                {
                    "id": "1326510204503785472",
                    "tenantId": "1258302372600094720",
                    "status": "Active",
                    "userId": "1310502425002172416",
                    "isMainPerson": false,
                    "occupation": "Consultant",
                    "folderId": "1",
                    "roles": "create_transfers,manage_transfers,read_transfers,manage_accounts,open_accounts,read_accounts,create_cards,manage_cards,read_cards,manage_beneficiaries,manage_members,read_members",
                    "createdOn": "2025-01-08T11:17:58.121Z",
                    "modifiedOn": null,
                    "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
                    "modifiedBy": null
                },
                {
                    "id": "1357622485384339456",
                    "tenantId": "1258302372600094720",
                    "status": "Active",
                    "userId": "1347186835516612608",
                    "isMainPerson": false,
                    "occupation": "Coordinator",
                    "folderId": "FolderKik",
                    "roles": "create_transfers,manage_transfers,read_transfers,manage_accounts,open_accounts,read_accounts,create_cards,manage_cards,read_cards,manage_beneficiaries,manage_members,read_members",
                    "createdOn": "2025-04-04T07:47:03.922Z",
                    "modifiedOn": null,
                    "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
                    "modifiedBy": null
                }
            ],
            "registrationCountryCode": "BG",
            "status": "Active",
            "registrationRiskCountryCode": "BG",
            "registrationCode": "180638111",
            "registrationDate": "2024-07-03T21:00:00.000Z",
            "vatCode": "BG180638111",
            "registrationNumber": "180638111",
            "registrationAddressLine": "Line 1",
            "registrationAddressTownId": "Sofia",
            "registrationAddressZipCode": "1000",
            "mailingCountryCode": "BG",
            "mailingAddressTownId": "Sofia",
            "mailingAddressZipCode": "1000",
            "mailingAddressLine": "Line 1",
            "preferredLanguageCode": "ENG",
            "checkAML": true,
            "phoneNumber": {
                "countryCode": "BG",
                "value": "888456789"
            },
            "email": "cust_user_001@abv.bg",
            "folderId": "Folder01",
            "cardEnabled": false,
            "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
            "modifiedBy": null,
            "createdOn": "2024-07-04T07:54:56.619Z",
            "modifiedOn": "2025-04-04T07:47:04.715Z"
        },
        {
            "id": "1258741118950629376",
            "tenantId": "1258302372600094720",
            "externalCorporationId": 28217,
            "externalCustomerId": 138348,
            "name": "CorpSecondWithLongName",
            "customerSubtypeCode": "MB",
            "customerGroupCode": "EASYPS_CUST",
            "relatedPersons": [
                {
                    "id": "1258741118963212288",
                    "tenantId": "1258302372600094720",
                    "status": "Active",
                    "userId": "1258398250311200768",
                    "isMainPerson": true,
                    "occupation": "",
                    "folderId": null,
                    "roles": null,
                    "createdOn": "2024-07-05T11:07:49.040Z",
                    "modifiedOn": null,
                    "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
                    "modifiedBy": null
                },
                {
                    "id": "1326509932498976768",
                    "tenantId": "1258302372600094720",
                    "status": "Active",
                    "userId": "1310502425002172416",
                    "isMainPerson": false,
                    "occupation": "Beneficial Owner",
                    "folderId": "1",
                    "roles": "create_transfers,manage_transfers,read_transfers,manage_accounts,open_accounts,read_accounts,create_cards,manage_cards,read_cards,manage_beneficiaries,manage_members,read_members",
                    "createdOn": "2025-01-08T11:16:53.271Z",
                    "modifiedOn": null,
                    "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
                    "modifiedBy": null
                }
            ],
            "registrationCountryCode": "BG",
            "status": "Active",
            "registrationRiskCountryCode": "BG",
            "registrationCode": "180638731",
            "registrationDate": "2024-07-04T21:00:00.000Z",
            "vatCode": "BG180638731",
            "registrationNumber": "180638731",
            "registrationAddressLine": "line1",
            "registrationAddressTownId": "sofia",
            "registrationAddressZipCode": "1000",
            "mailingCountryCode": "BG",
            "mailingAddressTownId": "sofia",
            "mailingAddressZipCode": "1000",
            "mailingAddressLine": "line2",
            "preferredLanguageCode": "ENG",
            "checkAML": true,
            "phoneNumber": {
                "countryCode": "BG",
                "value": "888125478"
            },
            "email": "cust_user_001@abv.bg",
            "folderId": "folder6",
            "cardEnabled": false,
            "createdBy": "08309a6c-4b8b-4edf-8c1f-f779d41af7be",
            "modifiedBy": null,
            "createdOn": "2024-07-05T11:07:49.043Z",
            "modifiedOn": "2025-01-08T11:16:54.499Z"
        }
    ]
}
 */

export function mapCorporationRows(array: Corporation[]): CorporationRow[] {

    return array.map((c) => ({
        id: c.id,
        name: c.name,
        createdOn: new Date(c.createdOn),
        registrationCode: c.registrationCode,
        accountNumber: "Account number here",
        category: "Category here",
        address: makeAddress(c),
        owner: getOwnerId(c),
        numberOfUsers: c.relatedPersons.length,
        numberOfCards: 0,
    }))
}

function makeAddress(c: Corporation): string {
    return `${c.registrationAddressLine}, ${c.registrationAddressTownId}, ${c.registrationCountryCode}, ${c.registrationAddressZipCode}`
}

function getOwnerId(c: Corporation): string {
    return c.relatedPersons.find(p => p.isMainPerson)?.userId
}

interface CorporationRow {
    id: string
    name: string
    accountNumber: string
    createdOn: Date
    category: string
    registrationCode: string
    address: string
    owner: string
    numberOfUsers: number
    numberOfCards: number
}

export default CorporationTable;